// Generated by purs version 0.15.15
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_String_Common from "../Data.String.Common/index.js";
import * as Halogen_HTML_Properties from "../Halogen.HTML.Properties/index.js";
import * as Halogen_Svg_Attributes_Align from "../Halogen.Svg.Attributes.Align/index.js";
import * as Halogen_Svg_Attributes_Baseline from "../Halogen.Svg.Attributes.Baseline/index.js";
import * as Halogen_Svg_Attributes_CSSLength from "../Halogen.Svg.Attributes.CSSLength/index.js";
import * as Halogen_Svg_Attributes_Color from "../Halogen.Svg.Attributes.Color/index.js";
import * as Halogen_Svg_Attributes_Duration from "../Halogen.Svg.Attributes.Duration/index.js";
import * as Halogen_Svg_Attributes_FillState from "../Halogen.Svg.Attributes.FillState/index.js";
import * as Halogen_Svg_Attributes_FontSize from "../Halogen.Svg.Attributes.FontSize/index.js";
import * as Halogen_Svg_Attributes_FontStretch from "../Halogen.Svg.Attributes.FontStretch/index.js";
import * as Halogen_Svg_Attributes_FontStyle from "../Halogen.Svg.Attributes.FontStyle/index.js";
import * as Halogen_Svg_Attributes_FontWeight from "../Halogen.Svg.Attributes.FontWeight/index.js";
import * as Halogen_Svg_Attributes_MarkerUnit from "../Halogen.Svg.Attributes.MarkerUnit/index.js";
import * as Halogen_Svg_Attributes_MaskUnit from "../Halogen.Svg.Attributes.MaskUnit/index.js";
import * as Halogen_Svg_Attributes_MeetOrSlice from "../Halogen.Svg.Attributes.MeetOrSlice/index.js";
import * as Halogen_Svg_Attributes_Orient from "../Halogen.Svg.Attributes.Orient/index.js";
import * as Halogen_Svg_Attributes_Path from "../Halogen.Svg.Attributes.Path/index.js";
import * as Halogen_Svg_Attributes_StrokeLineCap from "../Halogen.Svg.Attributes.StrokeLineCap/index.js";
import * as Halogen_Svg_Attributes_StrokeLineJoin from "../Halogen.Svg.Attributes.StrokeLineJoin/index.js";
import * as Halogen_Svg_Attributes_TextAnchor from "../Halogen.Svg.Attributes.TextAnchor/index.js";
import * as Halogen_Svg_Attributes_Transform from "../Halogen.Svg.Attributes.Transform/index.js";
import * as Safe_Coerce from "../Safe.Coerce/index.js";
import * as Web_HTML_Common from "../Web.HTML.Common/index.js";
var show = /* #__PURE__ */ Data_Show.show(Data_Show.showNumber);
var map = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var y2 = /* #__PURE__ */ (function () {
    var $23 = Halogen_HTML_Properties.attr("y2");
    return function ($24) {
        return $23(show($24));
    };
})();
var y1 = /* #__PURE__ */ (function () {
    var $25 = Halogen_HTML_Properties.attr("y1");
    return function ($26) {
        return $25(show($26));
    };
})();
var y = /* #__PURE__ */ (function () {
    var $27 = Halogen_HTML_Properties.attr("y");
    return function ($28) {
        return $27(show($28));
    };
})();
var xlinkHref = /* #__PURE__ */ Halogen_HTML_Properties.attrNS("xlink")("xlink:href");
var x2 = /* #__PURE__ */ (function () {
    var $29 = Halogen_HTML_Properties.attr("x2");
    return function ($30) {
        return $29(show($30));
    };
})();
var x1 = /* #__PURE__ */ (function () {
    var $31 = Halogen_HTML_Properties.attr("x1");
    return function ($32) {
        return $31(show($32));
    };
})();
var x = /* #__PURE__ */ (function () {
    var $33 = Halogen_HTML_Properties.attr("x");
    return function ($34) {
        return $33(show($34));
    };
})();
var width = /* #__PURE__ */ (function () {
    var $35 = Halogen_HTML_Properties.attr("width");
    return function ($36) {
        return $35(show($36));
    };
})();
var viewBox = function (x_) {
    return function (y_) {
        return function (w) {
            return function (h_) {
                return Halogen_HTML_Properties.attr("viewBox")(Data_String_Common.joinWith(" ")(map(show)([ x_, y_, w, h_ ])));
            };
        };
    };
};
var transform = /* #__PURE__ */ (function () {
    var $37 = Halogen_HTML_Properties.attr("transform");
    var $38 = Data_String_Common.joinWith(" ");
    var $39 = map(Halogen_Svg_Attributes_Transform.printTransform);
    return function ($40) {
        return $37($38($39($40)));
    };
})();
var to = /* #__PURE__ */ Halogen_HTML_Properties.attr("to");
var textAnchor = /* #__PURE__ */ (function () {
    var $41 = Halogen_HTML_Properties.attr("text-anchor");
    return function ($42) {
        return $41(Halogen_Svg_Attributes_TextAnchor.printTextAnchor($42));
    };
})();
var strokeWidth = /* #__PURE__ */ (function () {
    var $43 = Halogen_HTML_Properties.attr("stroke-width");
    return function ($44) {
        return $43(show($44));
    };
})();
var strokeOpacity = /* #__PURE__ */ (function () {
    var $45 = Halogen_HTML_Properties.attr("stroke-opacity");
    return function ($46) {
        return $45(show($46));
    };
})();
var strokeMiterLimit = /* #__PURE__ */ (function () {
    var $47 = Halogen_HTML_Properties.attr("stroke-miterlimit");
    var $48 = Data_Ord.max(Data_Ord.ordNumber)(1.0);
    return function ($49) {
        return $47(show($48($49)));
    };
})();
var strokeLineJoin = /* #__PURE__ */ (function () {
    var $50 = Halogen_HTML_Properties.attr("stroke-linejoin");
    return function ($51) {
        return $50(Halogen_Svg_Attributes_StrokeLineJoin.printStrokeLineJoin($51));
    };
})();
var strokeLineCap = /* #__PURE__ */ (function () {
    var $52 = Halogen_HTML_Properties.attr("stroke-linecap");
    return function ($53) {
        return $52(Halogen_Svg_Attributes_StrokeLineCap.printStrokeLineCap($53));
    };
})();
var strokeDashOffset = /* #__PURE__ */ (function () {
    var $54 = Halogen_HTML_Properties.attr("stroke-dashoffset");
    return function ($55) {
        return $54(show($55));
    };
})();
var strokeDashArray = /* #__PURE__ */ Halogen_HTML_Properties.attr("stroke-dasharray");
var stroke = /* #__PURE__ */ (function () {
    var $56 = Halogen_HTML_Properties.attr("stroke");
    return function ($57) {
        return $56(Halogen_Svg_Attributes_Color.printColor($57));
    };
})();
var ry = /* #__PURE__ */ (function () {
    var $58 = Halogen_HTML_Properties.attr("ry");
    return function ($59) {
        return $58(show($59));
    };
})();
var rx = /* #__PURE__ */ (function () {
    var $60 = Halogen_HTML_Properties.attr("rx");
    return function ($61) {
        return $60(show($61));
    };
})();
var repeatCount = /* #__PURE__ */ (function () {
    var $62 = Halogen_HTML_Properties.attr("repeatCount");
    var $63 = Data_Show.show(Data_Show.showInt);
    return function ($64) {
        return $62($63($64));
    };
})();
var refY = /* #__PURE__ */ (function () {
    var $65 = Halogen_HTML_Properties.attr("refY");
    return function ($66) {
        return $65(show($66));
    };
})();
var refX = /* #__PURE__ */ (function () {
    var $67 = Halogen_HTML_Properties.attr("refX");
    return function ($68) {
        return $67(show($68));
    };
})();
var r = /* #__PURE__ */ (function () {
    var $69 = Halogen_HTML_Properties.attr("r");
    return function ($70) {
        return $69(show($70));
    };
})();
var preserveAspectRatio = function (align) {
    return function (slice) {
        var align_str = (function () {
            if (align instanceof Data_Maybe.Nothing) {
                return "none";
            };
            if (align instanceof Data_Maybe.Just) {
                return Data_String_Common.joinWith("")([ "x", Halogen_Svg_Attributes_Align.printAlign(align.value0.x_), "Y", Halogen_Svg_Attributes_Align.printAlign(align.value0.y_) ]);
            };
            throw new Error("Failed pattern match at Halogen.Svg.Attributes (line 249, column 15 - line 251, column 80): " + [ align.constructor.name ]);
        })();
        return Halogen_HTML_Properties.attr("preserveAspectRatio")(Data_String_Common.joinWith(" ")([ align_str, Halogen_Svg_Attributes_MeetOrSlice.printMeetOrSlice(slice) ]));
    };
};
var points = /* #__PURE__ */ (function () {
    var $71 = Halogen_HTML_Properties.attr("points");
    var $72 = Data_Array.intercalate(Data_Monoid.monoidString)(" ");
    var $73 = map(function (v) {
        return show(v.value0) + ("," + show(v.value1));
    });
    return function ($74) {
        return $71($72($73($74)));
    };
})();
var pathLength = /* #__PURE__ */ (function () {
    var $75 = Halogen_HTML_Properties.attr("pathLength");
    return function ($76) {
        return $75(show($76));
    };
})();
var path = /* #__PURE__ */ (function () {
    var $77 = Halogen_HTML_Properties.attr("path");
    var $78 = Data_String_Common.joinWith(" ");
    return function ($79) {
        return $77($78(Halogen_Svg_Attributes_Path.toArrayString($79)));
    };
})();
var orient = /* #__PURE__ */ (function () {
    var $80 = Halogen_HTML_Properties.attr("orient");
    return function ($81) {
        return $80(Halogen_Svg_Attributes_Orient.printOrient($81));
    };
})();
var maskUnits = /* #__PURE__ */ (function () {
    var $82 = Halogen_HTML_Properties.attr("maskUnits");
    return function ($83) {
        return $82(Halogen_Svg_Attributes_MaskUnit.printMaskUnit($83));
    };
})();
var maskContentUnits = /* #__PURE__ */ (function () {
    var $84 = Halogen_HTML_Properties.attr("maskContentUnits");
    return function ($85) {
        return $84(Halogen_Svg_Attributes_MaskUnit.printMaskUnit($85));
    };
})();
var mask = /* #__PURE__ */ Halogen_HTML_Properties.attr("mask");
var markerWidth = /* #__PURE__ */ (function () {
    var $86 = Halogen_HTML_Properties.attr("markerWidth");
    return function ($87) {
        return $86(show($87));
    };
})();
var markerUnits = /* #__PURE__ */ (function () {
    var $88 = Halogen_HTML_Properties.attr("markerUnits");
    return function ($89) {
        return $88(Halogen_Svg_Attributes_MarkerUnit.printMarkerUnit($89));
    };
})();
var markerStart = /* #__PURE__ */ Halogen_HTML_Properties.attr("marker-start");
var markerMid = /* #__PURE__ */ Halogen_HTML_Properties.attr("marker-mid");
var markerHeight = /* #__PURE__ */ (function () {
    var $90 = Halogen_HTML_Properties.attr("markerHeight");
    return function ($91) {
        return $90(show($91));
    };
})();
var markerEnd = /* #__PURE__ */ Halogen_HTML_Properties.attr("marker-end");
var id = /* #__PURE__ */ Halogen_HTML_Properties.attr("id");
var href = /* #__PURE__ */ Halogen_HTML_Properties.attr("href");
var height = /* #__PURE__ */ (function () {
    var $92 = Halogen_HTML_Properties.attr("height");
    return function ($93) {
        return $92(show($93));
    };
})();
var from = /* #__PURE__ */ Halogen_HTML_Properties.attr("from");
var fontWeight = /* #__PURE__ */ (function () {
    var $94 = Halogen_HTML_Properties.attr("font-weight");
    return function ($95) {
        return $94(Halogen_Svg_Attributes_FontWeight.printFontWeight($95));
    };
})();
var fontVariant = /* #__PURE__ */ Halogen_HTML_Properties.attr("font-variant");
var fontStyle = /* #__PURE__ */ (function () {
    var $96 = Halogen_HTML_Properties.attr("font-style");
    return function ($97) {
        return $96(Halogen_Svg_Attributes_FontStyle.printFontStyle($97));
    };
})();
var fontStretch = /* #__PURE__ */ (function () {
    var $98 = Halogen_HTML_Properties.attr("font-stretch");
    return function ($99) {
        return $98(Halogen_Svg_Attributes_FontStretch.printFontStretch($99));
    };
})();
var fontSizeAdjust = /* #__PURE__ */ (function () {
    var $100 = Halogen_HTML_Properties.attr("font-size-adjust");
    return function ($101) {
        return $100(show($101));
    };
})();
var fontSize = /* #__PURE__ */ (function () {
    var $102 = Halogen_HTML_Properties.attr("font-size");
    return function ($103) {
        return $102(Halogen_Svg_Attributes_FontSize.printFontSize($103));
    };
})();
var fontFamily = /* #__PURE__ */ Halogen_HTML_Properties.attr("font-family");
var fillOpacity = /* #__PURE__ */ (function () {
    var $104 = Halogen_HTML_Properties.attr("fill-opacity");
    return function ($105) {
        return $104(show($105));
    };
})();
var fillAnim = /* #__PURE__ */ (function () {
    var $106 = Halogen_HTML_Properties.attr("fill");
    return function ($107) {
        return $106(Halogen_Svg_Attributes_FillState.printFillState($107));
    };
})();
var fill = /* #__PURE__ */ (function () {
    var $108 = Halogen_HTML_Properties.attr("fill");
    return function ($109) {
        return $108(Halogen_Svg_Attributes_Color.printColor($109));
    };
})();
var dur = /* #__PURE__ */ (function () {
    var f = function (unit_) {
        return Data_Maybe.maybe("")(function (val) {
            return show(val) + unit_;
        });
    };
    var printDuration = function (v) {
        return f("h")(v.hours) + (f("m")(v.minutes) + (f("s")(v.seconds) + f("i")(v.milliseconds)));
    };
    var $110 = Halogen_HTML_Properties.attr("dur");
    return function ($111) {
        return $110(printDuration($111));
    };
})();
var dominantBaseline = /* #__PURE__ */ (function () {
    var $112 = Halogen_HTML_Properties.attr("dominant-baseline");
    return function ($113) {
        return $112(Halogen_Svg_Attributes_Baseline.printBaseline($113));
    };
})();
var d = /* #__PURE__ */ (function () {
    var $114 = Halogen_HTML_Properties.attr("d");
    var $115 = Data_String_Common.joinWith(" ");
    return function ($116) {
        return $114($115(Halogen_Svg_Attributes_Path.toArrayString($116)));
    };
})();
var cy = /* #__PURE__ */ (function () {
    var $117 = Halogen_HTML_Properties.attr("cy");
    return function ($118) {
        return $117(show($118));
    };
})();
var cx = /* #__PURE__ */ (function () {
    var $119 = Halogen_HTML_Properties.attr("cx");
    return function ($120) {
        return $119(show($120));
    };
})();
var classes = /* #__PURE__ */ (function () {
    var $121 = Halogen_HTML_Properties.attr("class");
    var $122 = Data_String_Common.joinWith(" ");
    var $123 = Safe_Coerce.coerce();
    return function ($124) {
        return $121($122($123($124)));
    };
})();
var class_ = /* #__PURE__ */ (function () {
    var $125 = Halogen_HTML_Properties.attr("class");
    var $126 = Data_Newtype.un()(Web_HTML_Common.ClassName);
    return function ($127) {
        return $125($126($127));
    };
})();
var begin = /* #__PURE__ */ Halogen_HTML_Properties.attr("begin");
var attributeName = /* #__PURE__ */ Halogen_HTML_Properties.attr("attributeName");
export {
    attributeName,
    begin,
    class_,
    classes,
    cx,
    cy,
    d,
    dominantBaseline,
    dur,
    fill,
    fillAnim,
    fillOpacity,
    fontFamily,
    fontSize,
    fontSizeAdjust,
    fontStretch,
    fontStyle,
    fontVariant,
    fontWeight,
    from,
    to,
    href,
    id,
    markerStart,
    markerMid,
    markerEnd,
    markerUnits,
    markerWidth,
    markerHeight,
    mask,
    maskUnits,
    maskContentUnits,
    orient,
    path,
    points,
    pathLength,
    preserveAspectRatio,
    r,
    refX,
    refY,
    repeatCount,
    rx,
    ry,
    stroke,
    strokeDashArray,
    strokeDashOffset,
    strokeLineCap,
    strokeLineJoin,
    strokeMiterLimit,
    strokeOpacity,
    strokeWidth,
    textAnchor,
    transform,
    viewBox,
    width,
    height,
    x,
    y,
    x1,
    y1,
    x2,
    y2,
    xlinkHref
};
export {
    Max,
    Mid,
    Min,
    printAlign
} from "../Halogen.Svg.Attributes.Align/index.js";
export {
    Alphabetic,
    Auto,
    BaselineMiddle,
    Central,
    Hanging,
    Ideographic,
    Mathematical,
    NoChange,
    ResetSize,
    TextAfterEdge,
    TextBeforeEdge,
    UseScript,
    printBaseline
} from "../Halogen.Svg.Attributes.Baseline/index.js";
export {
    Cm,
    Em,
    Ex,
    Inches,
    Mm,
    NoCSSLength,
    Pc,
    Pct,
    Pt,
    Px,
    Rem,
    Vh,
    Vmax,
    Vmin,
    Vw,
    printCSSLength
} from "../Halogen.Svg.Attributes.CSSLength/index.js";
export {
    Named,
    NoColor,
    RGB,
    RGBA,
    printColor
} from "../Halogen.Svg.Attributes.Color/index.js";
export {
    Freeze,
    Remove,
    printFillState
} from "../Halogen.Svg.Attributes.FillState/index.js";
export {
    FontSizeLength,
    Large,
    Larger,
    Medium,
    Small,
    Smaller,
    XLarge,
    XSmall,
    XXLarge,
    XXSmall,
    printFontSize
} from "../Halogen.Svg.Attributes.FontSize/index.js";
export {
    printFontStretch
} from "../Halogen.Svg.Attributes.FontStretch/index.js";
export {
    printFontStyle
} from "../Halogen.Svg.Attributes.FontStyle/index.js";
export {
    printFontWeight
} from "../Halogen.Svg.Attributes.FontWeight/index.js";
export {
    StrokeWidth,
    UserSpaceOnUse,
    printMarkerUnit
} from "../Halogen.Svg.Attributes.MarkerUnit/index.js";
export {
    ObjectBoundingBox,
    UserSpaceOnUse_,
    printMaskUnit
} from "../Halogen.Svg.Attributes.MaskUnit/index.js";
export {
    Meet,
    Slice,
    printMeetOrSlice
} from "../Halogen.Svg.Attributes.MeetOrSlice/index.js";
export {
    AutoOrient,
    AutoStartReverse,
    printOrient
} from "../Halogen.Svg.Attributes.Orient/index.js";
export {
    Arc0,
    Arc1,
    Abs,
    Rel,
    Sweep0,
    Sweep1,
    a,
    c,
    h,
    l,
    m,
    q,
    s,
    t,
    toArrayString,
    v,
    z
} from "../Halogen.Svg.Attributes.Path/index.js";
export {
    printStrokeLineCap
} from "../Halogen.Svg.Attributes.StrokeLineCap/index.js";
export {
    printStrokeLineJoin
} from "../Halogen.Svg.Attributes.StrokeLineJoin/index.js";
export {
    AnchorEnd,
    AnchorMiddle,
    AnchorStart,
    printTextAnchor
} from "../Halogen.Svg.Attributes.TextAnchor/index.js";
export {
    Matrix,
    Rotate,
    Scale,
    SkewX,
    SkewY,
    Translate,
    printTransform
} from "../Halogen.Svg.Attributes.Transform/index.js";
